import { IssueAssignee, IssuePriority, IssueStatus } from "../issueTracking";
import { Tag } from "../Tag.model";

export enum CrashType {
  FATAL = "fatal",
  NON_FATAL = "non_fatal",
  ANR = "anr",
}

export interface CrashReport {
  report_type: CrashType;
  id: string;
  app_id: string;
  title: string;
  subtitle: string;
  exception_type: string;
  cluster_id: string;
  key: number;
  created: string;
  updated: string;
  first_seen: string;
  last_seen: string;
  time_since_first_seen_in_list: string;
  time_since_last_seen_in_list: string;
  timeSinceInBugList: string;
  tags: Array<Tag>;
  priority: IssuePriority;
  status: IssueStatus;
  assignee: IssueAssignee;
  last_event: string;
  crash_events_count: number;
  parent_id: string | null;
  linked_crash_groups_count: number;
}

export interface CrashActivity {
  activity_type: CrashActivityType;
  activity_description: string;
  activity_url: string | null;
  created: string;
  id: string;
  updated: string;
}

export enum CrashActivityType {
  PRIORITY = "Priority",
  STATUS = "Status",
  ASSIGNEE = "Assignee",
}

export interface CrashReportsResponse {
  items: CrashReport[];
  total: number;
}
